import { orgStore } from './orgStore';

/**
 * Returns the active org_id, throwing if none is set.
 *
 * Every write path should scope by this in addition to relying on RLS. RLS is
 * the actual security boundary — but a single missing or mis-written policy
 * would otherwise be enough to let a mutation cross a tenant boundary. The
 * explicit filter makes that a no-op update instead of a data leak.
 */
export function requireOrgId(): string {
  const orgId = orgStore.getOrgId();
  if (!orgId) throw new Error('No organization found');
  return orgId;
}

/**
 * Strips fields a client must never be able to change on an update: tenant
 * ownership (`org_id`), row ownership (`user_id`, `created_by`) and the primary
 * key. Prevents a caller from moving a row into another org via an update
 * payload that gets spread into `.update()`.
 */
export function stripImmutable<T extends Record<string, unknown>>(
  updates: T
): Omit<T, 'org_id' | 'user_id' | 'created_by' | 'id'> {
  const { org_id, user_id, created_by, id, ...safe } = updates;
  return safe;
}
